/*
 * File: serverConfig.ts
 * File Created: 2023-11-27 03:22:24
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-03-26 09:25:38
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import { Config } from "@/../config/default/serverConfig";
//let dConfig = require("@/config/default/debug");

var config: Config = {
    ip: "localhost",
    port: 3000,
    ssl: false,

    cgiPath: "api",
    filePath: "file",
    mocking: false,

    loginPath: "/auth/login/admin",
};
export default config;
